<template>
  <el-card>
    <el-row>
      <el-table :data="authorizar_data" :stripe="true">
        <el-table-column
          label="Servicios"
          :min-width="200"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              :value="scope.row.ServiceName"
              placeholder="Servicios"
              disabled
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column :min-width="150" align="center" header-align="center">
          <template slot-scope="scope">
            <el-button
              :type="scope.row.Actived == false ? 'danger' : 'success'"
              size="small"
              @click="InactivateActivateService(scope)"
              plain
              round
              >{{
                scope.row.Actived == false ? "Inactivar" : "Activar"
              }}</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          label="Mensaje en la Terminal"
          :min-width="350"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              :value="scope.row.MessageTerminal"
              placeholder="Mensaje en la Terminal"
              disabled
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="Razon de Inactivacion"
          :min-width="350"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-input
              size="small"
              :value="scope.row.Reason"
              placeholder="Razon de Inactivacion"
              disabled
            ></el-input>
          </template>
        </el-table-column>
        <el-table-column
          label="Estado"
          :min-width="150"
          align="center"
          header-align="center"
        >
          <template slot-scope="scope">
            <el-tag
              :type="scope.row.Actived == true ? 'danger' : 'success'"
              size="small"
              circle
              disabled
              >{{ scope.row.Actived == false ? "activo" : "Inactivo" }}</el-tag
            >
          </template>
        </el-table-column>
      </el-table>
    </el-row>
    <InactivationForm
      :makeItVisible="makeInactivationFormVisible"
      :ServiceRowData="ServiceRowData"
      @oncloseInactivationForm="oncloseInactivationForm"
      @rechargingServices="GetInactiveSemaphoreData"
    />
    <!--
    <el-row v-for="item in ServicesOptions" :key="item.value" type="flex" justify="space-around">
        
        <el-col :span="4" type="flex" justify="center space-around" >
            <el-input size="small" :value="item.label" placeholder="Servicios" disabled></el-input>
        </el-col>
        
        <el-col :offset="1" :span="1">
            <el-button type="danger" size="small" @click="InactivateService" plain round>{{ButtonLabel}}</el-button>
        </el-col>
        <el-col :offset="1" :span="7">
            <el-input size="small" placeholder="Mensaje en la Terminal" disabled></el-input>
        </el-col>
        <el-col :offset="1" :span="7">
            <el-input size="small" placeholder="Razon de Inactivacion" disabled>{{"Razon"}}</el-input>
        </el-col>
    </el-row>
    -->
  </el-card>
</template>

<script>
import InactivationForm from "@/views/modules/authorizer/switcher/InactivationForm/InactivationForm.vue";
export default {
  name: "",
  components: {
    InactivationForm
  },
  props: {
    authorizerData: {
      Type: Array,
      default: () => []
    }
  },
  data() {
    return {
      ServicesOptions: [
        {
          value: "MAGYPAGO",
          label: "MAGYPAGO"
        },
        {
          value: "NCFMOVIL",
          label: "NCFMOVIL"
        },
        {
          value: "FIDELIZACION",
          label: "FIDELIZACION"
        },
        {
          value: "TICKET",
          label: "TICKET"
        }
      ],
      ButtonLabel: "Inactivar",
      authorizar_data: [],
      makeInactivationFormVisible: false,
      ServiceRowData: []
    };
  },
  computed: {
    /*
    authorizar_data: () => {
      console.log("authoizerData: ", this.authorizerData)
      return this.authorizerData
    }
    */
  },
  methods: {
    InactivateActivateService(val) {
      //console.log("Inactivar", val);
      if (this.IsInRoles([this.roles.AdministradorDeAuthorizador])) {
        //console.log("Tiene los permisos del rol");
        if (val.row.Actived == false) {
          //console.log("Actived", val);
          this.makeInactivationFormVisible = true;
          this.ServiceRowData = val.row;
        } else if (val.row.Actived == true) {
          this.$confirm(
            `Esta a punto de reactivar el servicio ${val.row.ServiceName}. Desea continuar?`,
            "Cuidado",
            {
              confirmButtonText: "Continuar",
              cancelButtonText: "Cancelar",
              type: "warning"
            }
          )
            .then(() => {
              this.ReactivateService(val.row);
            })
            .catch(() => {
              this.$message({
                type: "info",
                message: `Ha cancelado la reactivacion del servicio ${val.row.ServiceName}`
              });
            });
        }
      } else {
        this.$message.error(
          "Usted no tiene los permisos nescesarios para realizar esta accion"
        );
      }
    },
    ReactivateService(row) {
      //console.log("ReactivateService row: ", row);
      row.Actived = false;
      this.$http
        .put("/api/tennos/ReactivateAuthorizerService", row)
        .then(() => {
          //console.log(resp);
          this.$message({
            type: "success",
            message: `Servicio ${row.ServiceName} reactivado con exito`
          });
          this.GetInactiveSemaphoreData();
        })
        .catch((err) => {
          console.error("error al reactivar el servicio: " + err);
        });
    },
    oncloseInactivationForm() {
      //console.log("oncloseInactivationForm closing dialog", form);
      this.makeInactivationFormVisible = false;
    },
    GetInactiveSemaphoreData(form) {
      this.$emit("rechargingServices", form);
      this.makeInactivationFormVisible = false;
    }
  },
  watch: {
    authorizerData(val) {
      //console.log("authorizerData watch", val);
      this.authorizar_data = val;
      //console.log("authorizar_data watch", this.authorizar_data);
    }
  }
};
</script>

<style scoped></style>
